export default __webpack_public_path__ + "static/media/infrastructure_transparent.ac96310c.webp";